import { z } from 'zod';
import { TimelineSlot, WidgetType, ZodBaseWidgetConfiguration } from '../../types';
import { BaseThirdPartyAd, ZodBaseThirdPartyAdWidgetConfigurationDetails } from '../types';
import { BroadsignWidget } from './BroadsignWidget';

export type BroadsignAd = BaseThirdPartyAd & {
    popUrl: string;
};

export const ZodBroadsignWidgetConfigurationDetails = ZodBaseThirdPartyAdWidgetConfigurationDetails;

export type BroadsignWidgetTimelineSlotParams = {
    ad: BroadsignAd;
};

export type BroadsignWidgetTimelineSlot = TimelineSlot<
    BroadsignWidgetTimelineSlotParams,
    BroadsignWidget
>;

export type BroadsignWidgetConfigurationDetails = z.infer<
    typeof ZodBroadsignWidgetConfigurationDetails
>;

export const ZodBroadsignWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.BROADSIGN),
    config: ZodBroadsignWidgetConfigurationDetails,
});

export type BroadsignWidgetConfiguration = z.infer<typeof ZodBroadsignWidgetConfiguration>;
